import React from "react";
import {
  Stack,
  Group,
  TextInput,
  Button,
  ActionIcon,
  Text,
} from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons";

const SelectOptionsEditor = ({ value = [], onChange, disabled = false }) => (
  <Stack spacing="xs">
    <Text size="xs" color="dimmed">
      Options for select list (English / Chinese labels).
    </Text>
    {(value || []).map((item, idx) => (
      <Group key={idx} spacing="sm" align="flex-end" noWrap>
        <TextInput
          placeholder="Label (English)"
          size="xs"
          sx={{ flex: 1 }}
          disabled={disabled}
          value={item.label ?? ""}
          onChange={(e) => {
            const next = value.map((row, i) =>
              i === idx ? { ...row, label: e.target.value } : row
            );
            onChange?.(next);
          }}
        />
        <TextInput
          placeholder="Label (Chinese)"
          size="xs"
          sx={{ flex: 1 }}
          disabled={disabled}
          value={item.cname ?? ""}
          onChange={(e) => {
            const next = value.map((row, i) =>
              i === idx ? { ...row, cname: e.target.value } : row
            );
            onChange?.(next);
          }}
        />
        <ActionIcon
          variant="subtle"
          size="sm"
          disabled={disabled}
          onClick={() => onChange?.(value.filter((_, i) => i !== idx))}
        >
          <IconTrash size={14} />
        </ActionIcon>
      </Group>
    ))}
    <Button
      size="xs"
      w="fit-content"
      variant="light"
      disabled={disabled}
      leftIcon={<IconPlus size={14} />}
      onClick={() => onChange?.([...(value || []), { label: "", cname: "" }])}
    >
      Add option
    </Button>
  </Stack>
);

export default SelectOptionsEditor;
